import Loadable from 'react-loadable';
import { defaultLoadableConfig } from '../../../../ReactSharedScripts/modules/common/index';
import { ListLoadingPlaceholder } from '../../../../ReactSharedScripts/modules/list/listPage/ListLoadingPlaceholder';
import { preloadApi } from '../../../../ReactSharedScripts/utils/preloadApi';

export const DealsListEntry = Loadable({
	loader: () =>
		import('../../../../ReactSharedScripts/modules/deals/list/DealsList').then((m) => m.DealsListWithProviders),
	loading: () => (
		<ListLoadingPlaceholder
			titleCode={10588}
			columnsCount={7}
			skipNavigation
		/>
	),
});

export const AutomationLogListEntry = Loadable({
	beforeLoad: () => preloadApi('/automation/logListJson'),
	loader: () =>
		import('../../../../ReactSharedScripts/modules/automation/logList/AutomationLogList').then(
			(m) => m.AutomationLogListWithProviders,
		),
	loading: () => (
		<ListLoadingPlaceholder
			titleCode={13954}
			columnsCount={7}
			skipTotalItemsCount
		/>
	),
});

export const AutomationDetailEntry = Loadable({
	beforeLoad: () =>
		preloadApi('/automation/commonDetailsJson', {
			includeRouteId: true,
			includeParamsFromUrl: ['organizationId'],
		}),
	loader: () =>
		import('../../../../ReactSharedScripts/modules/automation/detail/AutomationDetail').then(
			(m) => m.AutomationDetail,
		),
	...defaultLoadableConfig,
});

export const AutomationListEntry = Loadable({
	loader: () =>
		import('../../../../ReactSharedScripts/modules/automation/list/AutomationList').then(
			(m) => m.AutomationListWithProviders,
		),
	loading: () => (
		<ListLoadingPlaceholder
			titleCode={13201}
			hasColumnSwitcher
		/>
	),
});

export const PeriodicComponentsListEntry = Loadable({
	loader: () =>
		import(
			'../../../../ReactSharedScripts/modules/periodicComponents/list/PeriodicComponentsListWithProviders'
		).then((m) => m.PeriodicComponentsListWithProviders),
	loading: () => (
		<ListLoadingPlaceholder
			titleCode={10693}
			hasColumnSwitcher
			columnsCount={9}
			skipNavigation
		/>
	),
});

export const FlexNetHostListEntry = Loadable({
	loader: () =>
		import('../../../../ReactSharedScripts/modules/flexNet/flexNetHost/list/FlexNetHostListWithProviders').then(
			(module) => module.FlexNetHostListWithProviders,
		),
	loading: () => (
		<ListLoadingPlaceholder
			titleCode={4333}
			hasColumnSwitcher
			columnsCount={3}
			skipFilters
		/>
	),
});

export const FlexNetCustomerListEntry = Loadable({
	loader: () =>
		import('../../../../ReactSharedScripts/modules/flexNet/flexNetCustomer/list/FlexNetCustomerList').then(
			(m) => m.FlexNetCustomerListWithProvider,
		),
	loading: () => (
		<ListLoadingPlaceholder
			titleCode={4372}
			hasColumnSwitcher
			columnsCount={5}
		/>
	),
});

export const FlexNetHostDetailEntry = Loadable({
	beforeLoad: () =>
		preloadApi('/flexNetHost/commonDetailsJson', {
			includeRouteId: true,
		}),
	loader: () =>
		import('../../../../ReactSharedScripts/modules/flexNet/flexNetHost/detail/FlexNetHostDetail').then(
			(m) => m.FlexNetHostDetail,
		),
	...defaultLoadableConfig,
});

export const FlexNetCustomerDetailEntry = Loadable({
	beforeLoad: () =>
		preloadApi('/flexNetCustomer/commonDetailsJson', {
			includeRouteId: true,
		}),
	loader: () =>
		import('../../../../ReactSharedScripts/modules/flexNet/flexNetCustomer/detail/FlexNetCustomerDetail').then(
			(m) => m.FlexNetCustomerDetail,
		),
	...defaultLoadableConfig,
});

export const FlexNetHostSettingsEntry = Loadable({
	loader: () =>
		import('../flexNet/flexNetHostSettings/FlexNetHostSettings').then((m) => m.ConnectedFlexNetHostSettings),
	beforeLoad: () => preloadApi('/flexNetHost/settingsJson'),
	...defaultLoadableConfig,
});

export const ClockwiseCompactViewEntry = Loadable({
	loader: () =>
		import('../../../../ReactSharedScripts/modules/clockwise/compactView/ClockwiseCompactView').then(
			(m) => m.ClockwiseCompactView,
		),
	// beforeLoad: () => preloadApi('/timecard/commonCompactData'),
	...defaultLoadableConfig,
});

export const CaoDetailEntry = Loadable({
	beforeLoad: () =>
		preloadApi('/cao/commonDetailsJson', {
			includeRouteId: true,
		}),
	loader: () =>
		import('../../../../ReactSharedScripts/modules/cao/detail/CaoDetailWithProviders').then(
			(m) => m.CaoDetailWithProviders,
		),
	...defaultLoadableConfig,
});

export const CaoCustomAgreementDetailEntry = Loadable({
	beforeLoad: () =>
		preloadApi('/customCao/commonDetailsJson', {
			includeRouteId: true,
		}),
	loader: () =>
		import('../../../../ReactSharedScripts/modules/customCao/detail/CaoCustomAgreementDetail').then(
			(m) => m.CaoCustomAgreementDetail,
		),
	...defaultLoadableConfig,
});

export const CustomCaoInstanceDetailDetailEntry = Loadable({
	beforeLoad: () =>
		preloadApi('/customCaoInstance/commonDetailsJson', {
			includeRouteId: true,
		}),
	loader: () =>
		import('../../../../ReactSharedScripts/modules/customCaoInstance/detail/CustomCaoInstanceDetail').then(
			(m) => m.CustomCaoInstanceDetail,
		),
	...defaultLoadableConfig,
});

export const CalculationSchemeListEntry = Loadable({
	loader: () =>
		import('../../../../ReactSharedScripts/modules/calculationScheme/list/CalculationSchemeList').then(
			(m) => m.CalculationSchemeListWithProviders,
		),
	loading: () => (
		<ListLoadingPlaceholder
			titleCode={9479}
			hasColumnSwitcher
			columnsCount={9}
		/>
	),
});

export const CalculationSchemeDetailEntry = Loadable({
	beforeLoad: () =>
		preloadApi('/calculationScheme/commonDetailsJson', {
			includeRouteId: true,
		}),
	loader: () =>
		import('../../../../ReactSharedScripts/modules/calculationScheme/detail/CalculationSchemeDetail').then(
			(m) => m.CalculationSchemeDetail,
		),
	...defaultLoadableConfig,
});

export const FormDesignerDetailEntry = Loadable({
	beforeLoad: () =>
		preloadApi('/formDesigner/commonDetailsJson', {
			includeRouteId: true,
			includeParamsFromUrl: ['organizationId', 'listData'],
		}),
	loader: () =>
		import('../../../../ReactSharedScripts/modules/formDesigner/detail/FormDesignerDetail').then(
			(m) => m.FormDesignerDetail,
		),
	...defaultLoadableConfig,
});

export const FormDesignerListEntry = Loadable({
	loader: () =>
		import('../../../../ReactSharedScripts/modules/formDesigner/list/FormDesignerList').then(
			(m) => m.FormDesignerListWithProviders,
		),
	loading: () => (
		<ListLoadingPlaceholder
			titleCode={5287}
			columnsCount={5}
		/>
	),
});

export const CalculationSchemeTestDetailEntry = Loadable({
	beforeLoad: () =>
		preloadApi('/calculationScheme/commonClockwiseTestJson', {
			includeRouteId: true,
		}),
	loader: () =>
		import('../../../../ReactSharedScripts/modules/calculationScheme/testDetail/CalculationSchemeTestDetail').then(
			(m) => m.CalculationSchemeTestDetail,
		),
	...defaultLoadableConfig,
});

export const CaoInstanceDetailEntry = Loadable({
	beforeLoad: () =>
		preloadApi('/caoInstance/commonDetailsJson', {
			includeRouteId: true,
		}),
	loader: () =>
		import('../../../../ReactSharedScripts/modules/caoInstance/detail/CaoInstanceDetail').then(
			(m) => m.CaoInstanceDetail,
		),
	...defaultLoadableConfig,
});

export const WmlDetailEntry = Loadable({
	beforeLoad: () =>
		preloadApi('/wml/detailsJson', {
			includeRouteId: true,
		}),
	loader: () => import('../../../../ReactSharedScripts/modules/wml/detail/WmlDetail').then((m) => m.WmlDetail),
	...defaultLoadableConfig,
});

export const CandidateStatusMappingListEntry = Loadable({
	loader: () =>
		import('../../../../ReactSharedScripts/modules/candidateStatusMapping/list/CandidateStatusMappingList').then(
			(m) => m.CandidateStatusMappingListWithProviders,
		),
	loading: () => (
		<ListLoadingPlaceholder
			titleCode={14150}
			columnsCount={11}
			skipFilters
			skipNavigation
			skipSearchField
		/>
	),
});

export const DealsDetailEntry = Loadable({
	beforeLoad: () =>
		preloadApi('/deal/commonDetailsJson', {
			includeRouteId: true,
		}),
	loader: () => import('../deals/detail/DealsDetail').then((m) => m.DealsDetail),
	...defaultLoadableConfig,
});

export const ConnectorListEntry = Loadable({
	loader: () =>
		import('../../../../ReactSharedScripts/modules/connector/list/ConnectorList').then(
			(m) => m.ConnectorListWithProviders,
		),
	loading: () => (
		<ListLoadingPlaceholder
			titleCode={14377}
			columnsCount={7}
		/>
	),
});

export const ConnectorDetailEntry = Loadable({
	beforeLoad: () =>
		preloadApi('/plugin/commonDetailsJson', {
			includeRouteId: true,
		}),
	loader: () =>
		import('../../../../ReactSharedScripts/modules/connector/detail/ConnectorDetail').then(
			(m) => m.ConnectorDetail,
		),
	...defaultLoadableConfig,
});

export const StructureEntry = Loadable({
	...defaultLoadableConfig,
	loader: () => import('../newBureaus/structure/Structure').then((m) => m.Structure),
});

export const BackofficeProcessingListEntry = Loadable({
	loader: () =>
		import('../../../../ReactSharedScripts/modules/backofficeProcessing/list').then(
			(m) => m.BackofficeProcessingListWithProviders,
		),
	loading: () => (
		<ListLoadingPlaceholder
			titleCode={15781}
			columnsCount={6}
		/>
	),
});

export const BackofficePaymentTransferFilesListEntry = Loadable({
	loader: () =>
		import('../../../../ReactSharedScripts/modules/backofficePaymentTransferFiles/list').then(
			(m) => m.BackofficePaymentTransferFilesListWithProviders,
		),
	loading: () => (
		<ListLoadingPlaceholder
			titleCode={15781}
			columnsCount={6}
		/>
	),
});
